import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { addDays, format, isSameDay } from 'date-fns';
import { grayLight, grayDark, blue, white } from '@bufferapp/ui/style/colors';
import { fontSize, fontWeightMedium } from '@bufferapp/ui/style/fonts';
import { useWeeklyDates } from '../hooks/useWeeklyDates';

const Day = styled.th`
  padding: 10px;
  font-weight: ${fontWeightMedium};
  font-size: ${fontSize};
  word-spacing: 8px;
  color: ${(props) => (props.isActive ? blue : grayDark)};
  background-color: ${white};
  text-align: center;
  border-top: 1px solid ${grayLight};
  border-bottom: 1px solid ${grayLight};
  border-right: 1px solid ${grayLight};
  position: sticky;
  top: 0;
  ${(props) =>
    props.headerShadow &&
    css`
      box-shadow: 0 5px 8px -7px rgba(0, 0, 0, 0.16);
    `}
  }
  &:first-child {
    border-left: 1px solid ${grayLight};
  }
`;

const HeaderRow = styled.tr`
  // Note Firefox will not fully respect the heights when dealing with table rows
  height: 32px;
`;

const DayOfWeekHeader = ({ currentDate, withDay, headerShadow }) => {
  const daysOfWeek = () => {
    // Sunday 1 or Sunday format
    const dateFormat = withDay ? 'EEEE d' : 'EEEE';
    const days = [];
    const { weekStart } = useWeeklyDates(currentDate);
    // Generates 7 days after start of the week date
    [...Array(7)].forEach((_, i) => {
      const day = addDays(weekStart, i);
      days.push(
        <Day
          key={day}
          headerShadow={headerShadow}
          isActive={isSameDay(new Date(), day) && withDay}
        >
          {format(day, dateFormat)}
        </Day>
      );
    });
    return <HeaderRow>{days}</HeaderRow>;
  };

  return <thead>{daysOfWeek()}</thead>;
};

DayOfWeekHeader.propTypes = {
  currentDate: PropTypes.instanceOf(Date).isRequired,
  withDay: PropTypes.bool,
  headerShadow: PropTypes.bool,
};

DayOfWeekHeader.defaultProps = {
  withDay: false,
  headerShadow: false,
};

export default DayOfWeekHeader;
